/**
 * The view model's part dimension, by its key. A leaf, re-exported by `part-dimension.ts`: the launch
 * entry asks only whether a work area's view model has this dimension (`useWorkAreaHasParts`), so it
 * does not carry the part filter's rules and words (about 3 KB; T-0770, the entry budget).
 */
export const PART_DIMENSION_KEY = 'part';
